
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./live": () => {
return Promise.all(/*  | __federation_expose_live */ [__webpack_require__.e("474"), __webpack_require__.e("336"), __webpack_require__.e("947"), __webpack_require__.e("566"), __webpack_require__.e("395")]).then(() => (() => (__webpack_require__(8822))));
},
"./ClassAccess": () => {
return Promise.all(/*  | __federation_expose_ClassAccess */ [__webpack_require__.e("474"), __webpack_require__.e("336"), __webpack_require__.e("947"), __webpack_require__.e("566"), __webpack_require__.e("259")]).then(() => (() => (__webpack_require__(4221))));
},
"./ManagementEventsWrapper": () => {
return Promise.all(/*  | __federation_expose_ManagementEventsWrapper */ [__webpack_require__.e("474"), __webpack_require__.e("336"), __webpack_require__.e("947"), __webpack_require__.e("566"), __webpack_require__.e("296")]).then(() => (() => (__webpack_require__(2705))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };